module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/db29be0389f54914dc40e33214d9d8cc.svg";